export const BODY_TYPES = {
  SUV: 'SUV',
  PICKUP: 'Pickup',
  MINIVAN: 'Minivan',
  CONVERTIBLE: 'Convertible',
  HATCHBACK: 'Hatchback',
  COUPE: 'Coupe',
  STATION_WAGON: 'Station Wagon',
  SEDAN: 'Sedan',
};
